import { RouteConfig } from "vue-router";

const perfil: RouteConfig = {
  path: "/perfil",
  name: "perfil",
  component: () => import(/* webpackChunkName: "perfil" */ "@/views/Perfil.vue"),
};

export default perfil;
